<template>
	<div class="main">
		<div class="main-container container">
			<div class="heading">Derek Tan</div>
			<p class="main-tag tag" :class="{ready: ready}">Web Developer</p>

			<p class="desc">I’m a creative technologist with a passion in building polished digital web experiences. Please contact me at <a class="link" href="https://www.linkedin.com/in/derek-tan-8359b97/" target="_blank">LinkedIn</a>.</p>

			<h2 class="section-head tag" :class="{ready: ready}">Featured Projects</h2>
			<ul class="work-list" :class="{ready: workReady}">
				<li class="work" v-for="(item, key) in work" v-bind:key="key">
					<div v-if="key === 0" class="rule top"></div>
					<a class="work-link" :href="item.url" :data-index="key" target="_blank">{{item.name}}</a>
					<div class="rule"></div>
				</li>
			</ul>
			
		</div>
	</div>

</template>

<script>
import { mapGetters } from 'vuex';
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import Effect from '../helpers/Effect';
import { isMobile } from 'mobile-device-detect';

export default {
	data() {
		return {
			ready: false,
			workReady: false,
			desc: null
		}
	},

	methods: {		
		initWebGL() {
			const dev = false;

			// WebGL
			const container = document.body;
			const itemsWrapper = document.querySelector('.work-list');			
			const effect = new Effect(container, itemsWrapper, this.work);			

			if(dev)		
				console.log(effect);
		}
	},
	computed: mapGetters(["work", "loaded", "scroll"]),

	watch: {
		// Wait for transition
		loaded: function() {
			setTimeout(()=> {
				this.ready = true;				
			}, 500);			
		},

		// Right after "Wipe" transition
		scroll: function() {

			// Enable scrolling
			document.body.style.overflowY = "visible";

			// Tween Desc text					
			gsap.to(this.desc.lines, {
				yPercent: 0,
				autoAlpha: 1,			
				stagger: 0.1,
				duration: 1,
				ease: "power2.out",
				/*onComplete: ()=> {
					this.workReady = true;
					//this.desc.revert();
				}*/
			});			

			// Section head 
			gsap.to(".section-head", { 
				autoAlpha: 1, yPercent: 0, duration: 1, delay: this.desc.lines.length * .1, ease: "power2.out",
			});	

			// Tween Rules
			gsap.to(".rule", {
				width: "100%",
				duration: 1,
				ease: "power2.out",
				stagger: .1,
				delay: .25				
			});		

			// Set work text to tween
			this.workReady = true;	

			// Init GL
			if(!isMobile)
				this.initWebGL();		
		},

		// After work is loaded
		work: function() {
						
			// Wait for DOM update
			this.$nextTick(function () {
					
				// Split Work titles
				const title = new SplitText(".work-link", {
					type: "chars",
					charsClass: "char"
				});
				title.chars.forEach((element, index) => {			
					element.style.transitionDelay = (.03 * index) + "s";
				});				
			});
		}
	},

	// Lifecycle	
	mounted() {		
		const CHAR_DELAY = .48;
		
		// Name text
		const tag = new SplitText(".main-tag", {
			type: "chars",
			charsClass: "char"
		});
		tag.chars.forEach((element, index) => {			
			element.style.transitionDelay = (CHAR_DELAY + (.03 * index)) + "s";
		});

		// Split Desc text
		const desc = new SplitText(".desc", {
			type: "lines"				
		});
		gsap.set(desc.lines, {
			yPercent: 110,
			autoAlpha: 0			
		});
		this.desc = desc;

		// Pre-empt Section head
		gsap.set(".section-head", { 
			autoAlpha: 0, yPercent: 100
		});		
	}
}
</script>

<style scoped lang="scss">
@import "../styles/mixins.scss";

.main {
	position: relative;
	top: 0;
	left: 0;
	width: 100vw;
	/*height: 100vh;    */
	text-align: left;	
	color: map-get($colors, 'prime-light');
	z-index: 1;	
}

	.main-container {
		padding-right: 8.33vw;
	}

.section-head {	
	font-size: 15px;
	/*font-size: 0.781vw;*/
	margin-top: 120px;
	/*margin-top: 6.250vw;*/
	font-weight: 400;
	margin-bottom: 0.521vw;	
}

.desc {
	font-size: 25px;
	/*font-size: 1.302vw;*/
	padding-left: .23vw;
	margin-top: 30px;
	/*margin-top: 1.563vw;*/
	font-weight: 300;
	/*max-width: 45%;*/
	max-width: 720px;	
}

.work-list {
	list-style: none;
	font-size: 80px;
	/*font-size: 4.167vw;*/
    font-weight: 200;
    max-width: 800px;

	.work {
		position: relative;
		/*border-bottom: 1px solid #3f3f3f;*/
		/*width: 50%;*/
		padding-bottom: 12px;

		span {
			font-size: 14px;
		}

		.rule {
			position: absolute;
			border-top: 1px solid map-get($colors, 'prime-medium');
			width: 0%;
			height: 1px;
			left: 0;
			bottom: 0;

			&.top {
				top: 0;
				bottom: initial;
			}			
		}		

		a {
			display: block;
		}
	}
}

@include phone {
	.desc {
		font-size: 5.8vw;
		max-width: inherit;
		margin-top: 8.065vw;
	}
	.section-head {
		margin-top: 32.258vw;
		font-size: 3vw; /*4.032vw;*/
		margin-bottom: 2.688vw;
	}
	.work-list {
		font-size: 11.333vw;

		.work {
			width: 100%;
			padding-bottom: 9px;
		}
	}
}

@include tablet {
	.desc {
		/*font-size: 5.8vw;*/
		font-size: 3.255vw;
		max-width: inherit;
		padding-right: 5vw;		
		margin-top: 3.906vw;
	}

	.section-head {		
		margin-top: 15.625vw;
		font-size: 1.953vw;
		margin-bottom: 1.302vw;
	}

	.work-list {
		font-size: 50px;		
		font-size: 10.417vw;

		.work {
			width: 100%;
		}
	}
}
</style>